import React, { useEffect, useState } from "react";
import { Button, Container, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { loadTemplateToDetailsTab } from "../../actions/ManagePrescriptionAction";
import { AssetStore } from "../../assets/AssetsStore";
import { DUMMY_PRESCRIPTION } from "../../Helpers/Constants";
import {
  getLastPrescription,
  getLastPrescriptionAvailability,
  savePrescription,
  getmappedtemplateAvailability,
  viewTemplates,
  autosavePrescription,
  getPrescriptionAvailability,
} from "../../reducers/symptom.api";
import DetailsTab from "./Components/DetailsTab/DetailsTab";
import LastPrescriptionTab from "./Components/LastPrescriptionTab/LastPrescriptionTab";
import ConformationModal from "./Components/Modals/ConformationModal/ConformationModal";
import InformationModal from "./Components/Modals/InformationModal/InformationModal";
import PrintPreviewTab from "./Components/PrintPreviewTab/PrintPreviewTab";
import TemplatesTab from "./Components/TemplatesTab/TemplatesTab";
import PrescriptionDisplayModal from "../../components/PrescriptionDisplayModal/PrescriptionDisplayModal";
import styles from "./printprescription.module.scss";
import { Skeleton } from "antd";
import { DrDashboardContext } from "../DoctorDashboard/DoctorDashboard";
import {
  fetch_clientDetails,
  getCountryData,
} from "../../actions/MicrositeAction";

export const PrescriprionContext = React.createContext({});
export const PrescriprionProvider = PrescriprionContext.Provider;
export const prescriptionEnums = {
  optionName: {
    SYMPTOMS: "symptom",
    MEDICAL_HISTORY: "Medical /Family History",
    DIAGNOSIS: "Provisional / Final Diagnosis",
    MEDICATIONS: "Medications",
  },
};

function PrintPrescription() {
  let dispatch = useDispatch();
  let history = useHistory();
  const [isLastPrescriptionAvailable, setIsLastPrrescription] = useState(false);
  const [isAutoSaveAvailable, setIsAutoSaveAvailable] = useState(false);

  const { _appointmentId } = useParams();

  const { drDashboardData } = React.useContext(DrDashboardContext);
  const userData = JSON.parse(localStorage.getItem("userData"));

  console.log("drDashboardData", React.useContext(DrDashboardContext));
  const [tabHeaders, setTabHeaders] = useState([
    {
      name: "Details",
    },
    // {
    //   name: "Print preview",
    // },
    // {
    //     name: "Templates"
    // },{name: "Last Prescription"}
  ]);

  const items = [
    {
      label: <a href="https://www.antgroup.com">1st menu item</a>,
      key: "0",
    },
    {
      label: <a href="https://www.aliyun.com">2nd menu item</a>,
      key: "1",
    },
    {
      type: "divider",
    },
    {
      label: "3rd menu item",
      key: "3",
    },
  ];

  const [activeTab, setActiveTab] = useState(tabHeaders[0].name);
  const [selectedTemplate, setActiveTemplate] = useState();
  const [isMessageOPen, setMessageOpen] = useState(false);
  const [isLoadLastModal, setLoadLastModal] = useState(false);
  const [isAutosaveModal, setIsAutosaveModal] = useState(false);
  const [isLoadTemplateModal, setisLoadTemplateModal] = useState(false);
  const [isCompleted, setCompleted] = useState(false);
  const [isSubmitVisible, setIsSubmitVisible] = useState(false);
  const [isAutosave, setIsAutosave] = useState(false);
  let [prescriptoinList, setPrescriptionList] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [TemplateName, setTemplateName] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [isEnabled, setIsEnabled] = useState(false);
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(true);
  let [errormessage, seterrormessage] = useState("");
  const [shouldAutosave, setShouldAutosave] = useState(false);

  const [appointmentId] = useState(
    _appointmentId || drDashboardData?.appointmentId
  );

  let appointmentHistoryRedux = useSelector(
    (state) => state.appointmentHistory.selectedAppointment
  );

  console.log("appointmentId", appointmentId);
  console.log("appointmentHistory", appointmentHistoryRedux?.[0]);
  const [isPageloading, setPageLoading] = useState(true);
  const [clientDetails, setclientDetails] = useState();
  // const handleManageIsOpen = (flag) => setOpen(flag || false);

  const handleManageIsOpen = () => {
    togglehandleManageIsOpen(isOpen ? false : true);
  };

  const togglehandleManageIsOpen = (param) => setOpen(param ? param : false);

  const handleSelect = (eventKey) => {
    setSelectedItem(eventKey);
  };
  // const {
  //   patient_id,
  //   patient_name,
  //   date,
  //   gender,
  //   height_value,
  //   height_messurment,
  //   weight_value,
  //   weight_messurment,
  //   lmp,
  //   medicalHistory,
  //   medical_history_note,
  //   vaccinationStatus,
  //   vaccinationDoseCount,
  //   nonVaccinationReason,
  //   examinations,
  //   diagnosis,
  //   investigations,
  //   instructions,
  //   medications,
  //   followup_date,
  //   speciality,
  //   referral,
  //   referral_note,
  //   symptoms,
  // } = useSelector((state) => state?.managePrescription?.submissionData);

  const [wholeData, setWholeData] = useState({
    patientId: "",
    patientName: "",
    date: "",
    gender: "",
    heightValue: "",
    heightMessurment: "",
    weightValue: "",
    weightMessurment: "",
    lmp: "",
    medicalHistory: [],
    medicalHistoryNote: "",
    vaccinationStatus: false,
    vaccinationDoseCount: 0,
    nonVaccinationReason: "",
    examinations: [],
    diagnosis: [],
    investigations: [],
    investigationNote: "",
    instructions: [],
    instructionNote: "",
    medications: [],
    followUpDate: "",
    speciality: "",
    referral: "",
    referralNote: "",
    symptoms: [],
    symptomsNote: "",
    diagnosisNote: "",
    medicalHistoryNote: "",
    familyHistoryNote: "",
    diagnosticNote: "",
    issubmitvisible: false,
  });


  useEffect(() => {

    dispatch(fetch_clientDetails(userData.clinicname !="" ? userData.clinicname : "")).then(
      (res) => {
        console.info("res",res )
        console.info("userData.clinicname",userData.clinicname )
        setclientDetails(res)
        

      })
   
  }, [userData.userId])

  const handlePreviousPrescriptionAvailability = (res) => {
    console.log("API response:", res);
    setIsLastPrrescription(res.enablePreload);
    setIsAutoSaveAvailable(res.autoSaveAvailable);
    console.log("res.info");
  };

  const handletemplateAvailability = (res) => {
    // setIsLastPrrescription(res.info);
    console.log("handletemplateAvailability", res);
    setPrescriptionList(res);
  };



console.log("isEnabled",isEnabled)


  useEffect(() => {
    console.debug("appointmentId:", appointmentId);
    console.debug(
      "appointmentHistoryRedux?.[0].DoctorId:",
      appointmentHistoryRedux?.[0].DoctorId
    );
    console.debug(
      "appointmentHistoryRedux?.[0].patientId:",
      appointmentHistoryRedux?.[0].patientId
    );
    if (
      appointmentId &&
      appointmentHistoryRedux?.[0].DoctorId &&
      appointmentHistoryRedux?.[0].patientId
    ) {
      getLastPrescriptionAvailability(
        appointmentId,
        appointmentHistoryRedux?.[0].DoctorId,
        appointmentHistoryRedux?.[0].patientId,
        handlePreviousPrescriptionAvailability
      );
    }
  }, [
    appointmentId,
    appointmentHistoryRedux?.[0].DoctorId,
    appointmentHistoryRedux?.[0].patientId,
  ]);

  useEffect(() => {
    if (appointmentId) {
      setPageLoading(true);
      getPrescriptionAvailability(appointmentId, handleLoadLastPrescription);
    }
  }, [appointmentHistoryRedux?.[0].DoctorId]);

  const handleWholeData = (key, data) => {
    setWholeData((oldData) => ({ ...oldData, [key]: data }));
    console.log("key, data", key, data);
    handlepreviewEnable(wholeData);
    console.log("handleWholeData called");
  };

  let submissionData = useSelector(
    (state) => state?.managePrescription?.submissionData
  );

  const handleTabHeaderClick = (tab) => {
    setActiveTab(tab.name);
  };

  let separatePrescriptionList = (para_array, para_element) => {
    let newArray = [];

    para_array.map((element) => {
      newArray.push(element[para_element]);
    });

    return newArray;
  };

  useEffect(() => {
  handlepreviewEnable(wholeData);
}, [wholeData]);

  const handlepreviewEnable = (data) => {
  console.log("wholeData handlepreviewEnable ",data)
  const hasData =
    (wholeData.patientId || wholeData.patientName) || // patient info (any one ok)
    (wholeData.symptoms?.length > 0) ||
    (wholeData.medicalHistory?.length > 0) ||
    (wholeData.examinations?.length > 0) ||
    (wholeData.Diagnosis?.length > 0) ||
    (wholeData.investigations?.length > 0) ||
    (wholeData.instructions?.length > 0) ||
    (wholeData.medications?.length > 0) ||
    (wholeData.speciality?.length > 0 &&
      wholeData.referral?.length > 0 &&
      wholeData.referral_note?.length > 0);

  // ✅ Enable when any field has data
  setIsEnabled(!hasData);

  const timer = setTimeout(() => {
    setIsAutosave(false);
  }, 6000);

  return () => clearTimeout(timer);
};

  let handleAutosave = () => {
    setIsSaving(true);
    setIsAutosave(true);
    var todayDate = new Date();
    var todayTime = todayDate.getHours() + ":" + todayDate.getMinutes();
    var dd = String(todayDate.getDate()).padStart(2, "0");
    var mm = String(todayDate.getMonth() + 1).padStart(2, "0");
    var yyyy = todayDate.getFullYear();
    todayDate = dd + "/" + mm + "/" + yyyy;

    let submissionObject = {
      browserTimeZone: "",
      generalDetails: {
        doctorId: appointmentHistoryRedux?.[0].DoctorId,
        appointmentId: appointmentId,
        doctorName: appointmentHistoryRedux?.[0].doctorName,
        doctorQualification: wholeData.doctorQualification,
        licenseNumber: wholeData.registrationNumber,
        doctorAddressLine1: "Pokhran Road No. 2",
        doctorAddressLine2: "Thane (W)",
        cityPin: "Mumbai - 400610",
        isSignatureAvailable: false,
        patientId: appointmentHistoryRedux?.[0].patientId,
        patientName: appointmentHistoryRedux?.[0].patientName,
        patientAge:
          appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.age,
        patientGender:
          appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.gender,
        displayDate: appointmentHistoryRedux?.[0].appointmentDate,
        displayTime: appointmentHistoryRedux?.[0].appointmentTime,
        height:
        wholeData.heightValue && wholeData.heightValue !== "0"
          ? wholeData.heightValue + " " + wholeData.heightMessurment
          : "",
      // Conditionally add heightUnit only if height is present
      ...(wholeData.heightValue && wholeData.heightValue !== "0" && {
        heightUnit: wholeData.heightMessurment,
      }),
        weight:
        wholeData.weightValue && wholeData.weightValue !== "0"
          ? wholeData.weightValue + " " + wholeData.weightMessurment
          : "",
      // Conditionally add weightUnit only if weight is present
      ...(wholeData.weightValue && wholeData.weightValue !== "0" && {
        weightUnit: wholeData.weightMessurment,
      }),
      
        lmp: wholeData.lmp,
      },
      patientDetails: {
        patientId: appointmentHistoryRedux?.[0].patientId,
        patientName: appointmentHistoryRedux?.[0].patientName,
        dob: appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.dob,
        gender:
          appointmentHistoryRedux?.[0].patientDetails?.personalDetails?.gender,
          height:
          wholeData.heightValue && wholeData.heightValue !== "0"
            ? wholeData.heightValue + " " + wholeData.heightMessurment
            : "",
        // Conditionally add heightUnit only if height is present
        ...(wholeData.heightValue && wholeData.heightValue !== "0" && {
          heightUnit: wholeData.heightMessurment,
        }),
        weight:
        wholeData.weightValue && wholeData.weightValue !== "0"
          ? wholeData.weightValue + " " + wholeData.weightMessurment
          : "",
      // Conditionally add weightUnit only if weight is present
      ...(wholeData.weightValue && wholeData.weightValue !== "0" && {
        weightUnit: wholeData.weightMessurment,
      }),
      
        lmp: wholeData.lmp,
      },
      consultationNotes: {
        symptoms: wholeData.symptoms,
        symptomsNote: wholeData.symptomsNote,
        medicalHistory: wholeData.medicalHistory,
        medicalHistoryNote: wholeData.medicalHistoryNote,
        familyHistoryNote: wholeData.familyHistoryNote,
        diagnosticNote: wholeData.diagnosticNote,
        examinations: wholeData.examinations,
        diagnosis: wholeData.Diagnosis,
        diagnosisNote: wholeData.diagnosisNote,
        vaccinationStatus: wholeData.vaccinationStatus,
        vaccinationDoseCount: wholeData.vaccinationDoseCount,
        vaccinationNames: [],
        vaccinationName1: wholeData.vaccinationName1
          ? wholeData.vaccinationName1
          : "",
        vaccinationName2: wholeData.vaccinationName2
          ? wholeData.vaccinationName2
          : "",
        vaccinationName3: wholeData.vaccinationName3
          ? wholeData.vaccinationName3
          : "",
        vaccinationName4: wholeData.vaccinationName4
          ? wholeData.vaccinationName4
          : "",
        nonVaccinationReason: wholeData.nonVaccinationReason,
      },
      treatmentAdvice: {
        investigations:
          wholeData.investigations != "" && wholeData.investigations.length > 0
            ? wholeData.investigations
            : [],
        instructions: wholeData.instructions,
        instructionNote: wholeData.instructionNote,
        medications: wholeData.medications,
        diet: wholeData.diet,
      },
      followup: {
        date: wholeData.followUpDate,
        followUpNote: wholeData.followUpNote,
      },
      referral: {
        speciality: wholeData.speciality,
        referral: wholeData.referral,
        referralNote: wholeData.referralNote,
      },
    };

    if (
      wholeData.vaccinationDoseCount &&
      Number(wholeData.vaccinationDoseCount) > 0
    ) {
      [...Array(wholeData.vaccinationDoseCount)].map((each, key) => {
        if (submissionData[`vaccinationName${key + 1}`]) {
          submissionObject.consultationNotes.vaccinationNames.push(
            submissionData[`vaccinationName${key + 1}`]
          );
        }
      });
    }
    console.log("auto save", submissionObject);
    console.log(wholeData);
    autosavePrescription(submissionObject, autosaveres);
    setIsSaving(false);
    setIsAutosave(false);
    // setCompleted(true);
    //history.push("/Success")
  };

  const autosaveres = (res) => {
    if (res) {
      // setTimeout(() => {
      //   setIsSaving(false);
      //   setIsAutosave(false);
      // }, 6000);
    }
  };

  const getActiveComponent = () => {
    switch (activeTab) {
      case tabHeaders[0].name:
        return <DetailsTab />;
      // case tabHeaders[1].name:
      //   return <PrintPreviewTab />;
      // case tabHeaders[2].name:
      //   return <TemplatesTab />;
      // case tabHeaders[3].name:
      //   return <LastPrescriptionTab />;
      default:
        break;
    }
  };

  const handleWholeDataFromPrevPrescriptions = (data) => {
    const consultationNotes = data?.consultationNotes;
    const treatmentAdvice = data?.treatmentAdvice;
    const referalData = data?.referral;
    const patientData = data?.generalDetails;
    console.debug("referalData", patientData);
    handleWholeData(
      "heightValue",
      patientData?.height.trim().length > 0
        ? patientData?.height.replace(patientData?.heightUnit, "")
        : ""
    );
    handleWholeData("heightMessurment", patientData.heightUnit);
    handleWholeData(
      "weightValue",
      typeof patientData?.weight === "string" &&
        patientData?.weight.trim().length > 0
        ? patientData?.weight.replace(patientData?.weightUnit, "")
        : ""
    );
    handleWholeData("weightMessurment", patientData?.weightUnit);
    handleWholeData("lmp", patientData?.lmp === "NA" ? "" : patientData?.lmp);
    handleWholeData("diet", treatmentAdvice.diet);

    handleWholeData("symptoms", consultationNotes.symptoms);
    handleWholeData("symptomsNote", consultationNotes.symptomsNote);
    handleWholeData("examinations", consultationNotes.examinations);
    handleWholeData("medicalHistory", consultationNotes.medicalHistory);
    handleWholeData("medicalHistoryNote", consultationNotes.medicalHistoryNote);
    handleWholeData("familyHistoryNote", consultationNotes.familyHistoryNote);
    handleWholeData("diagnosticNote", consultationNotes.diagnosticNote);

    handleWholeData("Diagnosis", consultationNotes.diagnosis);
    handleWholeData("diagnosisNote", consultationNotes.diagnosisNote);
    handleWholeData("investigations", treatmentAdvice.investigations);
    handleWholeData("instructions", treatmentAdvice.instructions);
    handleWholeData("instructionNote", treatmentAdvice.instructionNote);
    handleWholeData("medications", treatmentAdvice.medications);
    handleWholeData("speciality", referalData.speciality);
    handleWholeData("referral", referalData.referral);
    handleWholeData("referralNote", referalData.referralNote);
    handleWholeData("followUpDate", data.followup.date);
    handleWholeData("followUpNote", data.followup.followUpNote);
    handleWholeData(
      "vaccinationDoseCount",
      consultationNotes.vaccinationDoseCount
    );
    handleWholeData("vaccinationNames", consultationNotes.vaccinationNames);
    handleWholeData("vaccinationStatus", consultationNotes.vaccinationStatus);
    handleWholeData("vaccinationNames", consultationNotes.vaccinationNames);
    handleWholeData("vaccinationName1", consultationNotes.vaccinationName1);
    handleWholeData("vaccinationName2", consultationNotes.vaccinationName2);
    handleWholeData("vaccinationName3", consultationNotes.vaccinationName3);
    handleWholeData("vaccinationName4", consultationNotes.vaccinationName4);
    handleWholeData(
      "nonVaccinationReason",
      consultationNotes.nonVaccinationReason
    );
  };

  const handleWholeDataFromtemplate = (data) => {
    console.log("handleWholeDataFromtemplate", data);
    const consultationNotes = data.consultationNotes;
    const treatmentAdvice = data.treatmentAdvice;
    const referalData = data.referral;
    handleWholeData("symptoms", consultationNotes.symptoms);
    handleWholeData("symptomsNote", consultationNotes.symptomsNote);
    handleWholeData("examinations", consultationNotes.examinations);
    handleWholeData("medicalHistory", consultationNotes.medicalHistory);
    handleWholeData("medicalHistoryNote", consultationNotes.medicalHistoryNote);
    handleWholeData("familyHistoryNote", consultationNotes.familyHistoryNote);
    handleWholeData("diagnosticNote", consultationNotes.diagnosticNote);
    handleWholeData("Diagnosis", consultationNotes.diagnosis);
    handleWholeData("diagnosisNote", consultationNotes.diagnosisNote);
    handleWholeData("investigations", treatmentAdvice.investigations);
    handleWholeData("instructions", treatmentAdvice.instructions);
    handleWholeData("instructionNote", treatmentAdvice.instructionNote);
    handleWholeData("medications", treatmentAdvice.medications);
    handleWholeData("speciality", "");
    handleWholeData("referral", "");
    handleWholeData("followUpDate", "");
    handleWholeData("followUpNote", "");
    handleWholeData(
      "vaccinationDoseCount",
      consultationNotes.vaccinationDoseCount
    );
    handleWholeData("vaccinationNames", "");
    handleWholeData("vaccinationStatus", "");
    handleWholeData("vaccinationNames", "");
    handleWholeData("vaccinationName1", "");
    handleWholeData("vaccinationName2", "");
  };

  const getTeplateTabClass = () => {
    return `${styles.templatesTab}`;
  };

  const toggleMessageModal = (param) => setMessageOpen(param ? param : false);
  const toggleLoadLastModal = (param) =>
    setLoadLastModal(param ? param : false);
  const toggleLoadtemplaeteModal = (param) =>
    setisLoadTemplateModal(param ? param : false);
  const toggleCompletedModal = (param) => setCompleted(param ? param : false);
  const toggleautosavedModal = (param) =>
    setIsAutosaveModal(param ? param : false);

  let getDoseCountAsNumber = () => {
    if (wholeData?.vaccinationDoseCount) {
      return [...Array(Number(wholeData?.vaccinationDoseCount))];
    } else {
      return [];
    }
  };

  let handleSubmit = () => {
    if (
  (appointmentHistoryRedux?.[0]?.patientId) ||
  (wholeData.patientName) || // if you want to include name later
  (wholeData.symptoms?.length > 0) ||
  (wholeData.medicalHistory?.length > 0) ||
  (wholeData.Diagnosis?.length > 0) ||
  (wholeData.ismedicationsavailable)
) {
      var todayDate = new Date();
      var todayTime = todayDate.getHours() + ":" + todayDate.getMinutes();
      var dd = String(todayDate.getDate()).padStart(2, "0");
      var mm = String(todayDate.getMonth() + 1).padStart(2, "0");
      var yyyy = todayDate.getFullYear();
      todayDate = dd + "/" + mm + "/" + yyyy;

      let submissionObject = {
        generalDetails: {
          doctorId: appointmentHistoryRedux?.[0].DoctorId,
          appointmentId: appointmentId,
          doctorName: appointmentHistoryRedux?.[0].doctorName,
          doctorQualification: wholeData.doctorQualification,
          licenseNumber: wholeData.registrationNumber,
          doctorAddressLine1: "Pokhran Road No. 2",
          doctorAddressLine2: "Thane (W)",
          cityPin: "Mumbai - 400610",
          isSignatureAvailable: false,
          patientId: appointmentHistoryRedux?.[0].patientId,
          patientName: appointmentHistoryRedux?.[0].patientName,
          patientAge:
            appointmentHistoryRedux?.[0]?.patientDetails?.personalDetails?.age,
          patientGender:
            appointmentHistoryRedux?.[0]?.patientDetails?.personalDetails
              ?.gender,
          displayDate: appointmentHistoryRedux?.[0].appointmentDate,
          displayTime: appointmentHistoryRedux?.[0].appointmentTime,
          height:
          wholeData.heightValue && wholeData.heightValue !== "0"
            ? wholeData.heightValue + " " + wholeData.heightMessurment
            : "",
        // Conditionally add heightUnit only if height is present
        ...(wholeData.heightValue && wholeData.heightValue !== "0" && {
          heightUnit: wholeData.heightMessurment,
        }),
        weight:
        wholeData.weightValue && wholeData.weightValue !== "0"
          ? wholeData.weightValue + " " + wholeData.weightMessurment
          : "",
      // Conditionally add weightUnit only if weight is present
      ...(wholeData.weightValue && wholeData.weightValue !== "0" && {
        weightUnit: wholeData.weightMessurment,
      }),
          lmp: wholeData.lmp.length > 0 ? wholeData.lmp : "NA",
        },
        patientDetails: {
          patientId: appointmentHistoryRedux?.[0].patientId,
          patientName: appointmentHistoryRedux?.[0].patientName,
          dob: appointmentHistoryRedux?.[0]?.patientDetails?.personalDetails
            ?.dob,
          gender:
            appointmentHistoryRedux?.[0]?.patientDetails?.personalDetails
              ?.gender,
              height:
              wholeData.heightValue && wholeData.heightValue !== "0"
                ? wholeData.heightValue + " " + wholeData.heightMessurment
                : "",
            // Conditionally add heightUnit only if height is present
            ...(wholeData.heightValue && wholeData.heightValue !== "0" && {
              heightUnit: wholeData.heightMessurment,
            }),
            weight:
            wholeData.weightValue && wholeData.weightValue !== "0"
              ? wholeData.weightValue + " " + wholeData.weightMessurment
              : "",
          // Conditionally add weightUnit only if weight is present
          ...(wholeData.weightValue && wholeData.weightValue !== "0" && {
            weightUnit: wholeData.weightMessurment,
          }),
          lmp: wholeData.lmp,
        },
        consultationNotes: {
          symptoms: wholeData.symptoms,
          symptomsNote: wholeData.symptomsNote,
          medicalHistory: wholeData.medicalHistory,
          medicalHistoryNote: wholeData.medicalHistoryNote,
          familyHistoryNote: wholeData.familyHistoryNote,
          examinations: wholeData.examinations,
          diagnosticNote: wholeData.diagnosticNote,
          diagnosis: wholeData.Diagnosis,
          diagnosisNote: wholeData.diagnosisNote,
          vaccinationStatus: wholeData.vaccinationStatus,
          vaccinationDoseCount: wholeData.vaccinationDoseCount,
          vaccinationNames: [],
          vaccinationName1: wholeData.vaccinationName1
            ? wholeData.vaccinationName1
            : "",
          vaccinationName2: wholeData.vaccinationName2
            ? wholeData.vaccinationName2
            : "",
          vaccinationName3: wholeData.vaccinationName3
            ? wholeData.vaccinationName3
            : "",
          nonVaccinationReason: wholeData.nonVaccinationReason,
        },
        treatmentAdvice: {
          investigations:
            wholeData.investigations != "" &&
            wholeData.investigations.length > 0
              ? wholeData.investigations
              : [],
          instructions: wholeData.instructions,
          instructionNote: wholeData.instructionNote,
          medications: wholeData.medications,
          diet: wholeData.diet,
        },
        followup: {
          date: wholeData.followUpDate,
          followUpNote: wholeData.followUpNote,
        },
        referral: {
          speciality: wholeData.speciality,
          referral: wholeData.referral,
          referralNote: wholeData.referralNote,
        },
      };

      if (
        wholeData.vaccinationDoseCount &&
        Number(wholeData.vaccinationDoseCount) > 0
      ) {
        getDoseCountAsNumber().map((elem, key) => {
          console.log("key", wholeData[`vaccinationName${key + 1}`]);
          if (wholeData[`vaccinationName${key + 1}`]) {
            submissionObject.consultationNotes.vaccinationNames.push(
              wholeData[`vaccinationName${key + 1}`]
            );
          }
        });
        /*  [...Array(wholeData.vaccinationDoseCount)].map((each, key) => {
           console.log("key", [...Array(wholeData.vaccinationDoseCount)])
           if (submissionData[`vaccinationName${key + 1}`]) {
             console.log(submissionData[`vaccinationName${key + 1}`])
             submissionObject.consultationNotes.vaccinationNames.push(
               submissionData[`vaccinationName${key + 1}`]
             );
           }
           else
           {
             console.log("each",each)
           }
         }); */
      }
      console.log(submissionObject);
      console.log(wholeData);
      savePrescription(submissionObject, fileDownload);
      setIsloading(true);
      //history.push("/Success")
    } else {
      let missingFields = [];
      if (
        !wholeData.symptoms ||
        wholeData.symptoms.length === 0 ||
        !wholeData.issymptomavailable
      ) {
        missingFields.push("Symptoms");
      }
      if (!wholeData.medicalHistory || wholeData.medicalHistory.length === 0) {
        missingFields.push("Medical History");
      }
      if (!wholeData.Diagnosis || wholeData.Diagnosis.length === 0) {
        missingFields.push("Provisional/Final Diagnosis");
      }
      if (!wholeData.ismedicationsavailable) {
        missingFields.push("Medications");
      }
      if (wholeData.vaccinationStatus === "Yes") {
        if (!wholeData.vaccinationDoseCount) {
          missingFields.push("Dose Count");
        } else {
          // Dynamically checking for vaccinationName based on dose count
          for (let i = 1; i <= wholeData.vaccinationDoseCount; i++) {
            const fieldName = `vaccinationName${i}`;
            if (!wholeData[fieldName] || wholeData[fieldName].trim() === "") {
              missingFields.push("Vaccination Name " + i);
            }
          }
        }
      }
      console.debug("missingFields", missingFields);
      if (missingFields.length > 0 && missingFields.length !== 0) {
        // Include the "Missing Section Name" in the message with HTML elements
        const message = (
          <div style={{ textAlign: "left" }}>
            <p>The following field(s) are mandatory:</p>
            <ul>
              {missingFields.map((field, index) => (
                <li style={{ color: "red" }} key={index}>
                  {field}
                </li>
              ))}
            </ul>
          </div>
        );

        // Set the message in the state
        seterrormessage(message);
        toggleMessageModal(true);
      } else {
        // Clear the message if there are no missing fields
        seterrormessage(null);

        // Optionally, hide the modal if there are no missing fields
        toggleMessageModal(false);
      }
      //seterrormessage(`${missingFields.join(', ')}.  can't be empty`)
    }
  };

  let goToBethanySite = () => {
    window.open("http://bethanyhospital.in", "_blank");
  };

  const fileDownload = (res) => {
    setIsloading(false);
    setCompleted(true);
    // const linkSource = `data:application/pdf;base64,${res.info}`;
    // const downloadLink = document.createElement("a");
    // var currentdate = new Date();
    // const fileName = `prescription_${currentdate}.pdf`;

    // downloadLink.href = linkSource;
    // downloadLink.download = fileName;
    // downloadLink.click();
  };

  let handleLoadlastPrescriptionClick = () => {
    toggleLoadLastModal(true);
  };

  let handleLoadautosavePrescriptionClick = () => {
    toggleautosavedModal(true);
  };

  let templateOnClick = (e, name) => {
    console.log("templateclick", e);
    setTemplateName(name);
    handleWholeData("templateId", e);
    //dispatch(loadTemplateToDetailsTab(templateData));
    //setActiveTab("Details");
    toggleLoadtemplaeteModal(true);
  };
  console.debug("isAutosave", isAutosave);

  const handleLoadLastPrescription = (res) => {
    setPageLoading(false);
    console.info("handleLoadLastPrescription", res);
    handleWholeDataFromPrevPrescriptions(res?.lastcreatedPrescription);
  };
  const handleLoadAutosavePrescription = (res) => {
    console.debug("handleLoadLastPrescription", res);
    handleWholeDataFromPrevPrescriptions(res.autosavepresciption);
  };
  const handleLoadTemplate = (res) => {
    console.log("handleLoadTemplate", res[0].tempData);
    handleWholeDataFromtemplate(res[0].tempData);
  };
  let handleSubmitLoadLast = () => {
    getLastPrescription(
      appointmentId,
      appointmentHistoryRedux?.[0].DoctorId,
      appointmentHistoryRedux?.[0].patientId,
      handleLoadLastPrescription
    );
    toggleLoadLastModal(false);
    setActiveTab("Details");
  };

  let handleSubmitLoadAutosave = () => {
    getLastPrescription(
      appointmentId,
      appointmentHistoryRedux?.[0].DoctorId,
      appointmentHistoryRedux?.[0].patientId,
      handleLoadAutosavePrescription
    );
    toggleautosavedModal(false);
    setActiveTab("Details");
  };

  let handleSubmitLoadtemplate = () => {
    viewTemplates(wholeData.templateId, handleLoadTemplate);
    toggleLoadtemplaeteModal(false);
    setActiveTab("Details");
  };

  console.debug("isAutosaveoutsideUseEffect", isAutosave);

  useEffect(() => {
    console.debug("isAutosaveinsideUseEffect", isAutosave);

    console.debug("useEffect hook triggered");
    if (!isAutosave && Object.keys(wholeData).length > 0) {
      console.log("wholeData object:", wholeData);
      const consultationNotes = wholeData.consultationNotes;
      if (wholeData) {
        const hasSymptoms =
          wholeData?.symptoms && wholeData?.symptoms.length > 0;
        const hasMedicalHistory =
          String(wholeData?.medicalHistory).trim() !== "";
        const hasExaminations =
          wholeData?.examinations && wholeData?.examinations.length > 0;
        const hasDiagnosis = String(wholeData?.diagnosis).trim() !== "";
        const hasVaccinationStatus =
          wholeData?.vaccinationStatus !== undefined &&
          wholeData?.vaccinationStatus !== false;

        console.log("hasSymptoms:", hasSymptoms);
        console.log("hasMedicalHistory:", hasMedicalHistory);
        console.log("hasExaminations:", hasExaminations);
        console.log("hasDiagnosis:", hasDiagnosis);
        console.log("hasVaccinationStatus:", hasVaccinationStatus);

        if (
          hasSymptoms ||
          hasMedicalHistory ||
          hasExaminations ||
          hasDiagnosis ||
          hasVaccinationStatus
        ) {
          console.log("Calling handleAutosave function");
          handleAutosave();
        }
      }
    }
    if (
      wholeData.symptoms &&
      wholeData.symptoms.length > 0 &&
      wholeData.medicalHistory &&
      wholeData.medicalHistory.length > 0 &&
      wholeData.Diagnosis &&
      wholeData.Diagnosis.length > 0 &&
      wholeData.ismedicationsavailable &&
      wholeData.issymptomavailable
    ) {
      console.info("button enabled");

      setIsSubmitEnabled(false);
    } else {
      setIsSubmitEnabled(true);
    }
    console.debug("wholeData", wholeData);
  }, [wholeData]);

  console.log("setSelectedItem", selectedItem);

  const handleMandatoryModalCallback = () => {
    toggleMessageModal(false);

    if (
      !wholeData.symptoms ||
      wholeData.symptoms.length === 0 ||
      !wholeData.issymptomavailable
    ) {
      setWholeData({
        ...wholeData,
        focus: prescriptionEnums.optionName.SYMPTOMS,
      });
    } else if (
      !wholeData.medicalHistory ||
      wholeData.medicalHistory.length === 0
    ) {
      setWholeData({
        ...wholeData,
        focus: prescriptionEnums.optionName.MEDICAL_HISTORY,
      });
    } else if (!wholeData.Diagnosis || wholeData.Diagnosis.length === 0) {
      setWholeData({
        ...wholeData,
        focus: prescriptionEnums.optionName.DIAGNOSIS,
      });
    } else if (!wholeData.ismedicationsavailable) {
      setWholeData({
        ...wholeData,
        focus: prescriptionEnums.optionName.MEDICATIONS,
      });
    }
  };

  return (
    <div className={styles.container}>
      {isPageloading ? (
        <PageLoader />
      ) : (
        <PrescriprionProvider value={{ wholeData, handleWholeData }}>
          <div className={styles.body}>
            <div className={styles.header}>
              <div>{/* <h1>{wholeData.doctorName} </h1> */}</div>
              {/* <div style={{ width: "150px" }}>
                <img
                  src="https://www.connect2mydoctor.com/img/geri-care-logo.png"
                  alt=""
                  style={{ width: "inherit" }}
                />
              </div> */}
            </div>
            <div className={styles.container}>
              <div className={styles.tabHeader}>
                <div className={styles.tabOptions}>
                  {tabHeaders.map((eachHeaded, key) => {
                    return (
                      <span
                        key={key}
                        onClick={() => {
                          handleTabHeaderClick(eachHeaded);
                        }}
                        className={
                          activeTab == eachHeaded.name
                            ? styles.activeTabHead
                            : null
                        }
                      >
                        {eachHeaded.name}
                      </span>
                    );
                  })}

                  {/* <Dropdown
                  className={getTeplateTabClass()}
                  onSelect={handleSelect}
                >
                  <Dropdown.Toggle variant="success" id="dropdown-basic">
                    Templates
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ maxHeight: '200px', overflowY: 'auto' }}>
                    {prescriptoinList.length > 0
                      ? prescriptoinList.map((eachPrescriptoin, key) => {
                          // console.log("eachPrescriptoin",eachPrescriptoin.tempName)
                          return (
                            <Dropdown.Item
                              key={key}
                              eventKey={eachPrescriptoin.tempName}
                              onClick={() => {
                                templateOnClick(
                                  eachPrescriptoin.tempId,
                                  eachPrescriptoin.tempName
                                );
                              }}
                              active={
                                selectedItem === eachPrescriptoin.tempName
                              }
                            >
                              {eachPrescriptoin.tempName}
                            </Dropdown.Item>
                          );
                        })
                      : ""}
                  </Dropdown.Menu>
                </Dropdown> */}

                  {isLastPrescriptionAvailable === "TRUE" && (
                    <span onClick={handleLoadlastPrescriptionClick}>
                      Last Prescription
                    </span>
                  )}
                  {isAutoSaveAvailable === "TRUE" && (
                    <span onClick={handleLoadautosavePrescriptionClick}>
                      Load from Draft
                    </span>
                  )}

                  {/* <span onClick={ handleManageIsOpen}>
                     Print Preview
                  </span> */}
                </div>

                {isSaving && (
                  <div className={styles.savingindicator}>Saving...</div>
                )}
              </div>

              <div className={styles.tabBody}>
                <p
                  style={{
                    width: "100%",
                    textAlign: "right",
                    color: "red",
                    fontSize: "15px",
                  }}
                >
                  * Mandatory
                </p>
                {getActiveComponent()}

                {activeTab === tabHeaders[0].name ? (
                  <div className={styles.submit_prescription}>
                    <Button
                      onClick={handleSubmit}
                       disabled={isEnabled}
                      className={styles.submit_prescription_button}
                    >
                      {isloading ? "Proccessing.." : "SUBMIT"}
                    </Button>
                    <Button
                      onClick={handleManageIsOpen}
                      className={styles.submit_prescription_button}
                      disabled={isEnabled}
                      style={{ marginLeft: "59px" }}
                    >
                      PREVIEW
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <PrescriptionDisplayModal
            isOpen={isOpen}
            onClose={handleManageIsOpen}
            wholeData={wholeData}
            appointmentHistoryRedux={appointmentHistoryRedux}
            clientDetails={clientDetails}
          />
          <InformationModal
            onSubmit={handleMandatoryModalCallback}
            title={errormessage}
            showModal={isMessageOPen}
            hidemodal={() => {
              toggleMessageModal(false);
            }}
            btntext="OK"
          />

          <ConformationModal
            onSubmit={(e) => {
              handleSubmitLoadLast();
            }}
            title={"Do you want to load the last prescription?"}
            showModal={isLoadLastModal}
            hidemodal={() => {
              toggleLoadLastModal(false);
            }}
          />

          <ConformationModal
            onSubmit={(e) => {
              handleSubmitLoadAutosave();
            }}
            title={"Do you want to load the unsaved prescription?"}
            showModal={isAutosaveModal}
            hidemodal={() => {
              toggleautosavedModal(false);
            }}
          />

          <ConformationModal
            onSubmit={(e) => {
              handleSubmitLoadtemplate();
            }}
            title={"Do you want to load the Template - " + TemplateName + " ?"}
            showModal={isLoadTemplateModal}
            hidemodal={() => {
              toggleLoadtemplaeteModal(false);
            }}
          />

          <InformationModal
            onSubmit={(e) => {
              // window.location.href = "https://bethanyhospital.in";
              toggleCompletedModal(false);
              history.push({
                pathname: "/dashboard",
                state: { page: "dashboard" },
              });
            }}
            title={"Prescription saved successfully."}
            showModal={isCompleted}
            hidemodal={() => {
              history.push("/dashboard");
              console.log("close");

              // window.location.href = "https://bethanyhospital.in";
              toggleCompletedModal(false);
            }}
          />
        </PrescriprionProvider>
      )}
    </div>
  );
}

export default PrintPrescription;

const PageLoader = () => {
  return (
    <>
      {[...Array(2)].map(() => (
        <Skeleton
          avatar
          paragraph={{
            rows: 4,
          }}
        />
      ))}
    </>
  );
};
